if (!customElements.get('home-shop-for')) {
  customElements.define(
    'home-shop-for',
    class HomeShopFor extends HTMLElement {
      constructor() {
        super();
        this._onEnter = this._onEnter.bind(this);
        this._onLeave = this._onLeave.bind(this);
        this.mq = window.matchMedia('(hover: hover) and (pointer: fine)');
      }

      connectedCallback() {
        this.links = this.querySelectorAll('[data-shop-for-link]');
        if (!this.links.length) return;

        this.links.forEach((a) => {
          a.addEventListener('mouseenter', this._onEnter);
          a.addEventListener('focus', this._onEnter);
        });
        this.addEventListener('mouseleave', this._onLeave);
      }

      disconnectedCallback() {
        if (!this.links || !this.links.length) return;
        this.links.forEach((a) => {
          a.removeEventListener('mouseenter', this._onEnter);
          a.removeEventListener('focus', this._onEnter);
        });
        this.removeEventListener('mouseleave', this._onLeave);
      }

      setActive(index) {
        const s = String(index);
        this.querySelectorAll('[data-shop-for-link]').forEach((el) => {
          el.classList.toggle('is-active', el.getAttribute('data-shop-for-index') === s);
        });
        this.querySelectorAll('[data-shop-for-panel]').forEach((el) => {
          el.classList.toggle('is-active', el.getAttribute('data-shop-for-panel') === s);
        });
      }

      _onEnter(e) {
        if (!this.mq.matches) return;
        const idx = e.currentTarget.getAttribute('data-shop-for-index');
        if (idx != null) this.setActive(idx);
      }

      _onLeave() {
        if (!this.mq.matches) return;
        this.setActive('0');
      }
    }
  );
}
